import LocationDescription from '../location-description';
import Map from '../map';

export default function LocationTab() {
    return (
        <div className="flex flex-col gap-10 items-center">
            <LocationDescription />
            <Map />
        </div>
    )
}